const sortingArray = ["size xs", "size s", "size m", "size l", "size xl", "size xxl"];
const sortSizes = (alternatives) => alternatives.sort(
  (a, b) => {
    var _a, _b, _c, _d, _e, _f;
    return sortingArray.indexOf((_c = (_b = (_a = a.offer) == null ? void 0 : _a.scopedProduct) == null ? void 0 : _b.size) == null ? void 0 : _c.toLowerCase()) - sortingArray.indexOf((_f = (_e = (_d = b.offer) == null ? void 0 : _d.scopedProduct) == null ? void 0 : _e.size) == null ? void 0 : _f.toLowerCase());
  }
);
export {
  sortSizes,
  sortingArray
};
